import { render, staticRenderFns } from "./CancelGeneralConsent.vue?vue&type=template&id=074083c9&scoped=true&"
import script from "./CancelGeneralConsent.vue?vue&type=script&lang=js&"
export * from "./CancelGeneralConsent.vue?vue&type=script&lang=js&"
import style0 from "./CancelGeneralConsent.vue?vue&type=style&index=0&id=074083c9&prod&lang=css&"
import style1 from "./CancelGeneralConsent.vue?vue&type=style&index=1&id=074083c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074083c9",
  null
  
)

export default component.exports